import { ptBR } from './pt-BR';
import { ptPT } from './pt-PT';
import { esUY } from './es-UY';
import { enUS } from './en-US';

export const messages = {
  'pt-BR': ptBR,
  'pt-PT': ptPT,
  'es-UY': esUY,
  'en-US': enUS,
};

export type Locale = keyof typeof messages;

export const defaultLocale: Locale = 'pt-BR';
